export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-948.fd663165.jpg";